/* eslint-disable camelcase */
/* eslint-disable no-bitwise */
/* eslint-disable space-infix-ops */
/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-const */
import { cloneDeep } from 'lodash';
import { v4 } from 'uuid';
import { autoMappings } from '../constants/gwBffDataMappingsAuto';
import { propMappings } from '../constants/gwBffDataMappingsProp';
import { formatContactInfoAuto, formatVehicleIncident, formatInjuryIncident, formatLossLocationAuto, formatHitObject, formatDescriptionAuto } from '../claim/updateClaimFormatFunctions/auto';
import { formatDwellingIncident, formatLostDamagedItems, formatPropertyIncidents, formatContactInfoProp, formatDwellingCode } from '../claim/updateClaimFormatFunctions/prop';
import { appendDescription, changePhoneNumberFormat, trimString } from '../claim/updateClaimFormatFunctions/shared';
import { mapLossCause } from '../constants/lossScenarioMappings';
import { insurerCodeNameMapping } from '../constants/insurerCodeNameMapping';

const unwrapValueDFS = (data) => {
  if (data && typeof data ==='object') {
    for (let [k, v] of Object.entries(data)) {
      if (k!=='address' && k!== 'lossLocationAddress' && k!== 'review' && typeof v === 'object') {
        if (v && Object.prototype.hasOwnProperty.call(v, 'value')) {
          data[k] = trimString(v.value);
        } else {
          unwrapValueDFS(v);
        }
      }
    }
  }
};

// Read value from the object according to the path provided.
const getValueWithPathArray = (obj, path) => {
  let currentReadValue = obj;
  let valueNotFound = false;
  path.forEach((key) => {
    if (currentReadValue[key] !== undefined && currentReadValue[key] !== null) {
      currentReadValue = currentReadValue[key];
    } else {
      valueNotFound = true;
    }
  });
  let res;
  if (valueNotFound) {
    res = null;
  } else {
    res = currentReadValue;
  }
  return res;
};

const setValueWithPathString = (obj, path, value) => {
  // exit function is value is not found
  if (value === null) {
    return;
  }

  path = path.split('.');
  let currentPosition = obj;
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < path.length; i++) {
    if (i !== path.length - 1) {
      if (!currentPosition[path[i]]) {
        currentPosition[path[i]] = {};
      }
      currentPosition = currentPosition[path[i]];
    } else {
      currentPosition[path[i]] = value;
    }
  }
};

// Find key start with the value in the object
const getKeyByValue = (object, value) => Object.keys(object).find((key) => key.endsWith(value));

// Deconstruct form data
const deconstructLossCause = (formData) => {
  if (formData.abonly?.data) {
    Object.assign(formData, formData.abonly.data);
    formData.abOnlyLossScenario = formData.secLossCause;
    formData.secLossScenario = formData.lossCause;
    formData.lossCause = 'injury_only';
    if (formData.lossCause && formData.secLossScenario) {
      appendDescription(formData, `${mapLossCause(formData.lossCause, 'auto')} - ${mapLossCause(formData.secLossScenario, 'auto')}`, true);
    }
  } else if (formData.property?.data) {
    Object.assign(formData, formData.property.data);
    if (formData.lossCause) {
      formData.description = formData.whatHappened || formData.description;
      appendDescription(formData, `${mapLossCause(formData.lossCause, 'property')}`, true);
    }
  } else if (formData.auto?.data) {
    Object.assign(formData, formData.auto.data);
    formData.secLossScenario = formData[getKeyByValue(formData, formData.lossCause)];
    if (formData.lossCause && formData.secLossScenario) {
      appendDescription(formData, `${mapLossCause(formData.lossCause, 'auto')} - ${mapLossCause(formData.secLossScenario, 'auto')}`, true);
    }
  } else {
    Object.assign(formData, formData.auto);
  }
  delete formData.auto;
  delete formData.property;
  delete formData.abonly;
};

// Deconstruct submittedData.claim_type obejct and distribute the values into different attributes.
const deconstructClaimTypeObject = (claim) => {
  if (claim.claim_type?.vehicle) {
    if (!claim.abonly) {
      claim.whichVehicleWasInvolved = claim.claim_type.vehicle;
    }
    claim.claim_type = claim.claim_type.claim_type;
  } else if (claim.claim_type?.property) {
    claim.whichPropertyWasInvolved = {};
    claim.whichPropertyWasInvolved.address = claim.claim_type.property.address;
    claim.whichPropertyWasInvolved.type = claim.claim_type.property.type;
    claim.claim_type = claim.claim_type.claim_type;
  }
};

const deconstructContainer = (formData) => {
  Object.assign(formData, formData.container);
  delete formData.container;
};

// Format fire/policy info
const formatOfficialInfo = (formData) => {
  const fireReported = formData.reportedFire;
  const policeReported = formData.reportedPolice;
  if (fireReported || policeReported) {
    const officials = [];
    if (fireReported) {
      const fireOfficial = formData.fire || {};
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(fireOfficial)) {
        if (typeof value === 'object' && Object.keys(value).length !== 0 && (value.department || value.reportNumber)) {
          officials.push({
            type: 'fire',
            name: trimString(value.department) || null,
            reportNumber: trimString(value.reportNumber),
          });
        }
      }
    }
    if (policeReported) {
      const policeOfficial = formData.police || {};
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(policeOfficial)) {
        if (typeof value === 'object' && Object.keys(value).length !== 0 && (value.department || value.reportNumber)) {
          officials.push({
            type: 'police',
            name: trimString(value.department) || null,
            reportNumber: trimString(value.reportNumber),
          });
        }
      }
    }
    if (officials.length > 0) {
      formData.officials = officials;
    }
  }
};

const formatNotes = (formData) => {
  let notes = [];
  if (formData.shareAdditionalDetails && formData.updateAdditionalDetailsNote) {
    let additionalDetailsNote = {
      body: trimString(formData.shareAdditionalDetails),
      subject: 'Digital FNOL - Additional Details',
      topic: 'fnol',
      action: 'post',
      temporaryId: formData.additionalDetailsNoteTemporaryId,
    };
    notes.push(additionalDetailsNote);
  }
  if (formData.newReporter && formData.reporter && Object.keys(formData.reporter).length !== 0 && formData.updateReporterNote) {
    let reporterNote = {
      body: `${formData.reporter.firstName} - ${formData.reporter.lastName} - ${formData.reporter.relationshipToPolicyHolder} - ${formData.reporter.email} - ${changePhoneNumberFormat(formData.reporter.number)}`,
      subject: 'Digital FNOL - Alternate Contact',
      topic: 'fnol',
      action: 'post',
      temporaryId: formData.reporter.noteTemporaryId,
    };
    notes.push(reporterNote);
  }
  if (formData.abDriver?.peopleInTheOtherVehiclesInfo?.[0] && formData.updateAbDriverNote) {
    const abDriver = formData.abDriver.peopleInTheOtherVehiclesInfo[0];
    const temporaryId = abDriver.noteTemporaryId;
    const abonlyVehicleDriverNote = {
      body: `First Name - ${abDriver.firstName}, Last Name - ${abDriver.lastName}, Phone Number: ${changePhoneNumberFormat(abDriver.number)}, Address - ${abDriver.address?.value}, Driver's License Number - ${abDriver.license?.licenseNumber}, Issuing Province - ${abDriver.license?.issuingProvince}, Insurance Company - ${insurerCodeNameMapping[abDriver.insuranceInfo?.insurer]||'UNKNOWN'}, Policy Number - ${abDriver.insuranceInfo?.policyNumber}`,
      subject: 'Digital FNOL - Other Driver Information',
      topic: 'fnol',
      action: 'post',
      temporaryId,
    };
    notes.push(abonlyVehicleDriverNote);
  }
  if (formData.condo && Object.keys(formData.condo).length !== 0 && formData.updateCondoNote && (formData.condo.number || formData.condo.companyName)) {
    const condoManagementNote = {
      body: `${formData.condo.companyName} - ${changePhoneNumberFormat(formData.condo.number)}`,
      subject: 'Digital FNOL - Property Management Company',
      topic: 'fnol',
      action: 'post',
      temporaryId: formData.condo.noteTemporaryId,
    };
    notes.push(condoManagementNote);
  }
  if (formData.services?.rentalType === 'own_rental') {
    const ownRentalNote = {
      topic: 'fnol',
      subject: 'Digital FNOL - Rental Vehicle',
      body: 'Customer indicated they already have a rental vehicle',
      action: 'post',
      temporaryId: v4(),
    };
    notes.push(ownRentalNote);
  }
  formData.notes = notes;
};

// Pre-processing the format of formData to facilitate date model mapping.
const formatProcessing = (formData) => {
  unwrapValueDFS(formData);
  deconstructClaimTypeObject(formData);
  deconstructLossCause(formData);
  deconstructContainer(formData);
  formatOfficialInfo(formData);
  formatNotes(formData);
  if (formData.claim_type === 'Vehicle') {
    if (formData.lossCause !== 'injury_only' || formData.secLossScenario === 'occupantThirdPartyVehicle') {
      formatVehicleIncident(formData);
    }
    formatInjuryIncident(formData);
    formatLossLocationAuto(formData);
    formatContactInfoAuto(formData);
    formatHitObject(formData);
    formatDescriptionAuto(formData);
  } else if (formData.claim_type === 'Home') {
    formatDwellingIncident(formData);
    formatLostDamagedItems(formData);
    formatContactInfoProp(formData);
    formatDwellingCode(formData);
  }
  return formData;
};

export default function convertSubmissionObjectToGW(bffData) {
  try {
    // return bffData;
    let formData = cloneDeep(bffData);
    const formattedBffData = formatProcessing(formData);
    // eslint-disable-next-line prefer-const
    let submittedDataGW = {};
    let mappings;
    if (formData.claim_type === 'Vehicle') {
      mappings = autoMappings;
    } else if (formData.claim_type === 'Home') {
      mappings = propMappings;
    }
    for (const gwDataPath in mappings) {
      if (Object.prototype.hasOwnProperty.call(mappings, gwDataPath)) {
        const bffDataPath = mappings[gwDataPath];
        setValueWithPathString(
          submittedDataGW,
          gwDataPath,
          getValueWithPathArray(formattedBffData, bffDataPath),
        );
      }
    }
    if (submittedDataGW.lineOfBusiness === 'Home') {
      formatPropertyIncidents(submittedDataGW);
    }
    return submittedDataGW;
  } catch (error) {
    console.log(error);
  }
}
